import {apsEnums} from "../../shared/dto/aps.enums";
import * as angular from "angular";
import * as _ from "lodash";
import {Colors} from "../../shared/config/constant.module";

import confirmationTemplate from "./templates/commonConfirmationDialog.tpl.html";

export interface EnumOption {
  text: string;
  value: any;
}

export interface UIUtilityService {
  confirm(message: string, subject?: string, yes?: string, no?: string, onlyConfirm?: boolean, htmlBinding?: boolean, showTip?: boolean): angular.IPromise<boolean>;
  getListOptionsFromEnum(type: any, start?: number, end?: number, formatter?: (option: any) => string): EnumOption[];
  addEnumOption(type: any, value: number, options: EnumOption[], formatter?: (option: any) => string): void;
  getSeverityColor(severity: apsEnums.Severity): string;
  getRejectColor(rejectIndex: number): string;
  getEfficiencyColor(efficiency: number): string;
  getCavityCorrelationColor(efficiency: number): string;
}

export interface CommonConfirmationDialogCtrl {
  onlyConfirm: boolean;
  htmlBinding: boolean;
  showTip: boolean;
  message: string;
  subject: string;
  yes?: string;
  no?: string;

  save: () => void;
  close: () => void;
}

export interface CommonConfirmationDialogData {
  onlyConfirm: boolean;
  htmlBinding: boolean;
  showTip: boolean;
  message: string;
  subject: string;
  yes?: string;
  no?: string;
}

class UICommonConfirmationDialogCtrl implements CommonConfirmationDialogCtrl {

  private modalInstance: mm.foundation.modalInstance;
  public message: string;
  public subject: string;
  public yes: string;
  public no: string;
  public onlyConfirm: boolean;
  public htmlBinding: boolean;
  public showTip: boolean;

  constructor($modalInstance: mm.foundation.modalInstance,
              data: CommonConfirmationDialogData) {
    this.modalInstance = $modalInstance;
    this.message = data.message;
    this.subject = data.subject ? data.subject : 'Confirm Request';
    this.yes = data.yes ? data.yes : 'Confirm';
    this.no = data.no ? data.no : 'Cancel';
    this.onlyConfirm = data.onlyConfirm;
    this.htmlBinding = data.htmlBinding;
    this.showTip = data.showTip;
  }

  save(): void {
    this.modalInstance.close(true);
  }

  close(): void {
    this.modalInstance.close(false);
  }
}

class UIUtilitySvc implements UIUtilityService {

  private $window: angular.IWindowService;
  private $modal: mm.foundation.modal;

  constructor($window: angular.IWindowService, $modal: mm.foundation.modal) {
    this.$window = $window;
    this.$modal = $modal;
  }

  addEnumOption(type: any, value: number, options: EnumOption[], formatter?: (option: any) => string): void {
    formatter = formatter || _.startCase;
    options.push({text: formatter(type[value]), value: value});
  }

  getListOptionsFromEnum(type: any, start?: number, end?: number, formatter?: (option: any) => string): EnumOption[] {
    let result = [];
    let i = start || 0;
    while (type[i]) {
      if (end && i > end) {
        break;
      }
      this.addEnumOption(type, i, result, formatter);
      i++;
    }

    return result;
  }

  confirm(message: string, subject?: string, yes?: string, no?: string, onlyConfirm: boolean = false, htmlBinding: boolean = false, showTip: boolean = true): angular.IPromise<boolean> {
    let modalConfirmation =
      this.$modal.open({
        template: confirmationTemplate,
        controller: 'uiCommonConfirmationDialogCtrl as vm',
        resolve: {
          data: (): CommonConfirmationDialogData => ({
            message: message,
            subject: subject,
            yes: yes,
            no: no,
            onlyConfirm: onlyConfirm,
            htmlBinding: htmlBinding,
            showTip: showTip
          })
        }
      });

    return modalConfirmation.result;
  }

  getSeverityColor(severity: apsEnums.Severity): string {
    if (severity === apsEnums.Severity.Critical) {
      return Colors.DEFECT_CRITICAL;
    } else if (severity === apsEnums.Severity.Major) {
      return Colors.DEFECT_MAJOR;
    } else if (severity === apsEnums.Severity.Minor) {
      return Colors.DEFECT_MINOR;
    } else if (severity === apsEnums.Severity.Event) {
      return Colors.DEFECT_EVENT;
    }
    return null;
  }

  getRejectColor(rejectIndex: number): string {
    switch (rejectIndex) {
      case 10:
        return Colors.REJECT_10;
      case 9:
        return Colors.REJECT_09;
      case 8:
        return Colors.REJECT_08;
      case 7:
        return Colors.REJECT_07;
      case 6:
        return Colors.REJECT_06;
      case 5:
        return Colors.REJECT_05;
      case 4:
        return Colors.REJECT_04;
      case 3:
        return Colors.REJECT_03;
      case 2:
        return Colors.REJECT_02;
      default:
        return Colors.REJECT_01;
    }
  }

  getEfficiencyColor(efficiency: number): string {
    if (efficiency >= 97) {
      return Colors.EFFICIENCY_HIGH;
    } else if (efficiency >= 95) {
      return Colors.EFFICIENCY_MEDIUM;
    } else if (efficiency >= 93) {
      return Colors.EFFICIENCY_LOW;
    } else {
      return Colors.EFFICIENCY_WARNING;
    }
  }

  getCavityCorrelationColor(efficiency: number): string {
    if (efficiency <= 3.0) {
      return Colors.EFFICIENCY_HIGH;
    } else if (efficiency <= 5.0) {
      return Colors.EFFICIENCY_MEDIUM;
    } else if (efficiency <= 7.0) {
      return Colors.EFFICIENCY_LOW;
    } else {
      return Colors.EFFICIENCY_WARNING;
    }
  }
}

export default angular
  .module('ui-common-confirmation', ['mm.foundation'])
  .service('uiUtilityService', UIUtilitySvc)
  .controller('uiCommonConfirmationDialogCtrl', UICommonConfirmationDialogCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/utility/uiUtility.service.ts